import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/eye.svg';

export const IconEye = createIconComponent(Icon);
